import styled from 'styled-components';
export const Root = styled.div `
    display: ${(props) => !!props.isShow ? 'block' : 'none'};
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    height: 100%;
    background-color: rgba(0,0,0,0.45);
    @media screen and (max-width:767px){
        .modal__body{
            max-width: calc(100vw - 16px);
        }
    }
    .modal__body {
        position: relative;
        top: 100px;
        margin: 8px auto;
        width: 520px;
        background-color: #fff;
        border: 0;
        // border-radius: 4px;
        -webkit-box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        .body__header {
            position: relative;
            padding: 12px 24px;
            color: rgba(0,0,0,0.85);
            font-weight: 500;
            font-size: 16px;
            line-height: 16px;
            background: #fff;
            background-color: #f2f2f2;
            border-radius: 4px 4px 0 0;
            button.btn {
                position: absolute;
                right: 0;
                top: 0;
                transform: rotateX(-50%);
                z-index: 10;
                width: 56px;
                height: 40px;
                padding: 0;
                color: rgba(0,0,0,0.45);
                font-weight: 700;
                line-height: 1;
                text-decoration: none;
                background: transparent;
                border: 0;
                outline: 0;
                cursor: pointer;
                -webkit-transition: color .3s;
                transition: color .3s;
            }
            button.btn:hover {
                color: rgba(0,0,0,0.75);
                text-decoration: none;
            }
            .hearder_desc {
                margin-left: 8px;
                font-size: 12px;
                line-height: 12px;
                color: #8c8c8c;
            }
        }
        .body__header.header--center {
            padding: 16px 24px;
        }
        .body__content {
            padding: 24px;
            font-size: 14px;
            line-height: 1.5;
            word-wrap: break-word;
            .content__line {
                padding-bottom: 17px;
                .content__key {
                    width: 100px;
                }
                .content__value {
                    flex: 1;
                    word-break: break-word;
                    word-wrap: break-word;
                }
            }
            div.content__line:last-of-type {
                padding-bottom: 0;
            }
        }
        .daYuFooter{
            position: relative;
            width: 100%;
            margin-top:10px;
            background: #fff;
            height:40px;
            margin-bottom:20px;
            .btm{
                width: 70px;
                height: 30px;
                position: absolute;
                right:20px;
            }
        }
    }
`;
